import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantProspeccion from "./components/MantProspeccion";
import { useZonaAgencia } from "../../context/ZonaAgenciaContext";
const MySwal = withReactContent(Swal);

const PageProspection = () => {
    const location = useLocation();
       

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [tiposDocumento, setTiposDocumento] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [departamentos, setDepartamentos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [provincias, setProvincias] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [distritos, setDistritos] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [provinciasSelect, setProvinciasSelect] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [distritosSelect, setDistritosSelect] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [actividadLaboralList, setActividadLaboralList] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [negocioProvinciasSelect, setNegocioProvinciasSelect] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [negocioDistritosSelect, setNegocioDistritosSelect] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [centrosPobladoSelect, setCentrosPobladoSelect] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
   
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const { zona, agencia} = useZonaAgencia();

    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.PROSPECTOS}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setTiposDocumento(rpta.data.tiposDocumento);
                setDepartamentos(rpta.data.departamentos);
                setProvincias(rpta.data.provincias);
                setDistritos(rpta.data.distritos);
                setActividadLaboralList(rpta.data.actividadesLaboral);
                setCentrosPobladoSelect(rpta.data.centrosPoblado);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const changeDepartamento = (value) => {
        setProvinciasSelect(provincias.filter((prov) => prov.codigo.substring(0,2) === value));
        setDistritosSelect(CONFIGURACIONES.INIT.ARRAY);
    };

    const changeProvincia = (value) => {
        setDistritosSelect(distritos.filter((dist) => dist.codigo.substring(0,4) === value));
    };

    const changeDepartamentoNegocio = (value) => {
        setNegocioProvinciasSelect(provincias.filter((prov) => prov.codigo.substring(0,2) === value));
        setNegocioDistritosSelect(CONFIGURACIONES.INIT.ARRAY);
    };

    const changeProvinciaNegocio = (value) => {
        setNegocioDistritosSelect(distritos.filter((dist) => dist.codigo.substring(0,4) === value));
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantProspeccion title={'Prospección'} idEdit={idRef} MySwal={MySwal} icon={iconActive}
                                        setIdRef={setIdRef} tiposDocumento={tiposDocumento} user={getUser()}
                                        showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} departamentos={departamentos} provincias={provinciasSelect} distritos={distritosSelect}
                                        changeDepartamento={changeDepartamento} changeProvincia={changeProvincia} changeDepartamentoNegocio={changeDepartamentoNegocio} zona={zona} agencia={agencia}
                                        changeProvinciaNegocio={changeProvinciaNegocio} negocioProvincias={negocioProvinciasSelect} negocioDistritos={negocioDistritosSelect} actividadLaboralList={actividadLaboralList} centrosPoblado={centrosPobladoSelect} />
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PageProspection;